// src/components/LogsDashboard/LogsDashboard.js
import React, { useEffect, useState } from "react";
import FetchService from "../../api/FetchService";
import PerformanceCard from "./PerformanceCard";
import LogsTable from "./LogsTable";
import HealthStatus from "./HealthStatus";
import MetricsPanel from "./MetricsPanel";

export default function LogsDashboard() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    const loadLogsDashboard = async () => {
        setLoading(true);
       await FetchService.fetchAPILogging("summary").then((result) => {
            setData(result.data.dashboard);
        });
        setLoading(false);
    };

    useEffect(() => {
        loadLogsDashboard();
        const interval = setInterval(loadLogsDashboard, 10000); // refresh every 10s
        return () => clearInterval(interval);
    }, []);

    if (loading) return <div className="text-center p-10 text-gray-400">Loading logsdashboard...</div>;

    return (
        <div className="min-h-screen bg-[#0b0f19] text-white p-6">
            <h1 className="text-3xl font-bold mb-6 text-cyan-400 drop-shadow-md">
                🧠 System Monitoring LogsDashboard
            </h1>

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-6">
                <PerformanceCard data={data.performance} />
                <HealthStatus data={data.health} />
                <MetricsPanel data={data.metrics} />
            </div>

            <LogsTable data={data.logs} />
        </div>
    );
}
